import _ from 'lodash';

export const areObjectEqual = (obj1: unknown, obj2: unknown) => _.isEqual(obj1, obj2);

export const groupBy = <T, K extends PropertyKey>(collection: T[], callback: (item: T) => K) =>
    _.groupBy(collection, callback);

export const sortBy = <T>(collection: T[], callback: (item: T) => unknown) => _.sortBy(collection, callback);

export const uniqBy = <T>(collection: T[], callback: (item: T) => unknown) => _.uniqBy(collection, callback);
